export const TRACKING_MSGS_MAP = {
  TRACKING_ERROR: 'TRK_ERROR',
  TRACKING_SUCCESS: 'TRK_SUCCESS',
};
